import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Link } from 'react-router-dom';
import { signIn, closeErrorMsg } from "../../redux/modules/auth";
import InputField from "../common/input-field"
import { useForm } from "../../hooks/use-form";
import PopupMsg from "../common/popup-msg"

const Login = () => {
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const mobile = useSelector(state => state.mobile);

    const [fields, setValue, setFieldValid, formIsValid, trigger, setTrigger, setValidate, setCheckValue, setAddress, setInn, setValueSelect, clearForm] = useForm({
        phone: {
          value: '',
          name: 'phone',
          type: 'tel',
          placeholder: '+7 000 000 00 00',
          validate: 'phone',
          valid: false,
          valid_reg: false
        }
    }, []);

    useEffect(() => {
        document.title = 'Авторизация | Личный кабинет Брокера THE FIVE';
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formIsValid()) {
            dispatch(
                signIn({
                    cmd: 'authorization-code',
                    //ReturnDebugData: true,
                    phone: fields.phone.value.replace(/[^0-9]/g, '')
                }
            ))
        }
    }

    const keyUp = () => {
        if(auth.error) dispatch(closeErrorMsg());
    }

    if(auth.is_veryfied && auth.is_loggined) {
        return <Navigate to='/' replace />
    }

    return (
        <>
            <div className="page page-auth">
                <div className="page-auth__img"></div>
                {mobile && <div className="logo"></div>}
                <div className="page-auth__content">
                    {!mobile && <div className="logo"></div>}

                    <form className={auth.error ? "form form_error fadeIn" : "form fadeIn"} onSubmit={handleSubmit}>
                        <div className="form__title">ВХОД в кабинет</div>
                        {!mobile && <div className="form__text">Введите свой номер телефона,<br/>чтобы получить смс код для входа в кабинет </div>}
                        <InputField
                            trigger={trigger}
                            setFieldValid={setFieldValid}
                            setValue={setValue}
                            keyUp={keyUp}
                            {...fields.phone}
                        />
                        <div className="form__error" dangerouslySetInnerHTML={{ __html: auth.error === 'Брокер в черном списке' ? 'Нет доступа. Обратитесь к&nbsp;администратору Вашей компании' : 'Введенный номер не&nbsp;зарегистрирован&nbsp;в&nbsp;Кабинете'}} />
                        <div className="form__buttons">
                            <button type="submit" className={auth.loading ? "btn btn_disable" : "btn"}>Войти в кабинет</button>
                            <Link to="/regist" className="btn btn_empty" onClick={() => dispatch(closeErrorMsg())}>Зарегистрироваться</Link>
                        </div>
                    </form>

                </div>
            </div>
        </>
    )
}

export default Login;